<template>
  <div class="container-fluid">
    <DriverModal
      :show="modalVisible"
      :driver="selectedDriver"
      :mode="modalMode"
      @close="modalVisible = false"
      @updated="loadDrivers"
    />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ pageTitle }}</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" :disabled="loading" @click="loadDrivers">
              Actualizar
            </button>
          </div>
          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="loading" class="text-center py-5">
              <div class="loader-box">
                <div class="loader-3"></div>
              </div>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Foto</th>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Patente</th>
                    <th>Estado</th>
                    <th>Deuda pendiente</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="driver in drivers" :key="driver.id">
                    <td>
                      <img
                        v-if="driver.driverPhoto"
                        :src="driver.driverPhoto"
                        alt="Foto"
                        class="rounded-circle"
                        style="width: 40px; height: 40px; object-fit: cover"
                      />
                      <span v-else class="avatar-placeholder">—</span>
                    </td>
                    <td>{{ driver.name || '—' }}</td>
                    <td>{{ driver.email || '—' }}</td>
                    <td>{{ driver.vehiclePlate || '—' }}</td>
                    <td>
                      <span class="badge" :class="statusClass(driver.status)">{{ driver.status || '—' }}</span>
                    </td>
                    <td>{{ formatCurrency(driver.outstandingDebt) }}</td>
                    <td>
                      <button class="btn btn-sm btn-primary" @click="verDriver(driver)">
                        Ver
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!loading && drivers.length === 0">
                    <td colspan="7" class="text-center text-muted py-4">
                      No hay conductores en esta sección
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchConductores } from '@/services/conductoresApi';
import DriverModal from '@/components/drivers/DriverModal.vue';

const TITLES = {
  activos: 'Conductores activos',
  inactivos: 'Conductores inactivos',
  'en-viaje': 'Conductores en viaje',
  calificando: 'Conductores calificando',
  tripaceptado: 'Viaje aceptado',
};

export default {
  name: 'ConductoresTablePage',
  components: { DriverModal },
  data() {
    return {
      drivers: [],
      loading: false,
      error: '',
      modalVisible: false,
      selectedDriver: null,
    };
  },
  computed: {
    tipo() {
      return this.$route.meta.conductoresTipo || this.$route.params.tipo || 'activos';
    },
    pageTitle() {
      return this.$route.meta.title || TITLES[this.tipo] || this.tipo;
    },
    modalMode() {
      return this.tipo === 'activos' ? 'activos' : 'view';
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.loadDrivers();
      },
    },
  },
  methods: {
    statusClass(status) {
      const s = String(status || '').toLowerCase();
      if (s === 'activo') return 'bg-success';
      if (s === 'solicitud') return 'bg-warning text-dark';
      if (s === 'inactivo') return 'bg-danger';
      if (s === 'enviaje' || s === 'tripaceptado') return 'bg-info text-dark';
      return 'bg-secondary';
    },
    async loadDrivers() {
      this.loading = true;
      this.error = '';
      try {
        this.drivers = await fetchConductores(this.tipo);
      } catch (err) {
        this.error = err.message || 'Error al cargar conductores';
        this.drivers = [];
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(value) {
      if (value == null || value === undefined) return '—';
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0,
      }).format(Number(value));
    },
    verDriver(driver) {
      this.selectedDriver = driver;
      this.modalVisible = true;
    },
  },
};
</script>
